export default __webpack_public_path__ + "static/media/zendesk.201c0202.svg";